const createContactDialogData = (contact, name, technologyDescription) => {
  return {
    ...contact,
    technologyName: name,
    technologyDescription
  };
};

export default createContactDialogData;
